import { BatchUploadActions } from 'src/models/files.model';
import { Action } from 'src/models/general.model';

export const requestRemoveUpload = (payload: string): Action => ({ type: BatchUploadActions.REMOVE_UPLOAD, payload });

export const requestReload = (payload: string): Action => ({ type: BatchUploadActions.RELOAD, payload });

export const requestCancelAll = (): Action => ({ type: BatchUploadActions.CANCEL_ALL });
